// @flow
import VisuallyHiddenText from './VisuallyHiddenText';
export default VisuallyHiddenText;
